import { gql } from "@apollo/client";export default gql`query planAggregate($where: subscription_plan_bool_exp) {
  planAggregate: subscription_plan_aggregate(where: $where) {
    aggregate {
      count
    }
  }
}
`;
